// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminReminders = (client) => ({
    /**
     * `POST /admin/reminders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersCreate
     * @source apps/backend/src/api/admin/reminders/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/reminders", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/reminders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersList
     * @source apps/backend/src/api/admin/reminders/route.ts
     */
    list: (query, headers) => client.fetch("/admin/reminders", { method: "GET", query, headers }),
    /**
     * `GET /admin/reminders/settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersSettingsRetrieve
     * @source apps/backend/src/api/admin/reminders/settings/route.ts
     */
    listSettings: (query, headers) => client.fetch("/admin/reminders/settings", { method: "GET", query, headers }),
    /**
     * `GET /admin/reminders/customer-feedback`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersCustomerFeedbackRetrieve
     * @source apps/backend/src/api/admin/reminders/customer-feedback/route.ts
     */
    retrieveCustomerFeedback: (query, headers) => client.fetch("/admin/reminders/customer-feedback", { method: "GET", query, headers }),
    /**
     * `GET /admin/reminders/index`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersIndexRetrieve
     * @source apps/backend/src/api/admin/reminders/index/route.ts
     */
    retrieveIndex: (query, headers) => client.fetch("/admin/reminders/index", { method: "GET", query, headers }),
    /**
     * `POST /admin/reminders/index`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersIndexCreate
     * @source apps/backend/src/api/admin/reminders/index/route.ts
     */
    updateIndex: (body, query, headers) => client.fetch("/admin/reminders/index", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/reminders/process`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersProcessCreate
     * @source apps/backend/src/api/admin/reminders/process/route.ts
     */
    updateProcess: (body, query, headers) => client.fetch("/admin/reminders/process", { method: "POST", body, query, headers }),
    /**
     * `PUT /admin/reminders/settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminRemindersSettingsPut
     * @source apps/backend/src/api/admin/reminders/settings/route.ts
     */
    updateSetting: (body, query, headers) => client.fetch("/admin/reminders/settings", { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=reminders.js.map